/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_nav_haiku_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the 5-7-5 syllable pattern`)
};

const es_syl_nav_haiku_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprueba el patrón de sílabas 5-7-5`)
};

const de_syl_nav_haiku_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfe das 5-7-5-Silbenmuster`)
};

const nl_syl_nav_haiku_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controleer het 5-7-5 lettergreeppatroon`)
};

const fr_syl_nav_haiku_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifiez le schéma de syllabes 5-7-5`)
};

const it_syl_nav_haiku_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica lo schema di sillabe 5-7-5`)
};

const pt_br2_syl_nav_haiku_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique o padrão silábico 5-7-5`)
};

const pt_syl_nav_haiku_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique o padrão silábico 5-7-5`)
};

const ja_syl_nav_haiku_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5-7-5の音節パターンをチェック`)
};

const zh_syl_nav_haiku_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检测5-7-5音节格式`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_nav_haiku_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_nav_haiku_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_nav_haiku_desc", locale)
	if (locale === "en") return en_syl_nav_haiku_desc(inputs)
	if (locale === "es") return es_syl_nav_haiku_desc(inputs)
	if (locale === "de") return de_syl_nav_haiku_desc(inputs)
	if (locale === "nl") return nl_syl_nav_haiku_desc(inputs)
	if (locale === "fr") return fr_syl_nav_haiku_desc(inputs)
	if (locale === "it") return it_syl_nav_haiku_desc(inputs)
	if (locale === "pt-BR") return pt_br2_syl_nav_haiku_desc(inputs)
	if (locale === "pt") return pt_syl_nav_haiku_desc(inputs)
	if (locale === "ja") return ja_syl_nav_haiku_desc(inputs)
	return zh_syl_nav_haiku_desc(inputs)
};